"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ({
  hasHeader
}) => ({
  position: 'absolute',
  top: hasHeader ? 4 : 2,
  insetEnd: hasHeader ? 4 : 2,
  color: 'gray.dark',
  borderRadius: 'sm',
  width: 8,
  height: 8,
  _focus: {
    boxShadow: 'outline'
  },
  _hover: {
    bg: 'gray.50'
  }
});
exports.default = _default;